import http from '.';

const api = http();

const getAll = () => {
  return api.get('/location');
};

const get = (id) => {
  return api.get(`location/${id}`);
};

const create = (data) => {
  return api.post('location', data);
};

const update = (id, data) => {
  return api.put(`/location`, data);
};

const remove = (id) => {
  return api.delete(`/location/${id}`);
};
const getBySearchText = (searchText) => {
  return api.get(`location/search/${searchText}`);
};

const getByFilter = (data) => {
  return api.get('location/search', {
    params: {
      locationName: data.locationName,
      locationStreetAddress1: data.locationStreetAddress1,
      locationPostalCode: data.locationPostalCode,
      locationCity: data.locationCity,
      countryId: data.countryId,
      countrySubdivisionId: data.countrySubdivisionId,
      siteId: data.siteId,
      sourceSystemReferenceId: data.sourceSystemReferenceId,
    },
  });
};

export default {
  getAll,
  get,
  create,
  update,
  remove,
  getBySearchText,
  getByFilter,
};
